import EntryActions from 'actions/EntryActions';
import * as analytics from 'analytics/Analytics';
import {COLLABORATION_ANALYTICS_ACTIONS} from 'constants/analytics-products';
import DocumentActions from 'notebook/documents/DocumentActions';
import documentStore from 'notebook/documents/DocumentStore';
import {fetchAndUpdateFileLockState} from 'notebook/realtime/DocumentEditorLockReduxActions';
import {RealtimeMessageType} from 'realtime/Constants';
import {GetRealtimeMessageData} from 'realtime/RealtimeChannel';
import {getCollaborationAnalyticsMetadata} from 'realtime/util/analytics/CollaborationAnalyticsMetadata';
import {isCurrentClient} from 'realtime/util/RealtimeUtil';
// @ts-expect-error
import entryStore from 'stores/EntryStore';
import APIUtil from 'util/APIUtil';

import type {DocumentUpdateMessageHandler} from './DocumentUpdateMessageHandlerConstants';

export const entryUpdateMessageHandler: DocumentUpdateMessageHandler<
  typeof RealtimeMessageType.ENTRY_UPDATE
> = {
  active: (
    fileId: string,
    {clientId}: GetRealtimeMessageData<typeof RealtimeMessageType.ENTRY_UPDATE>
  ): void => {
    fetchAndUpdateFileLockState(fileId);
    // Ignore the message if it is triggered by the current client since it should already have the latest changes
    if (clientId && !isCurrentClient(clientId)) {
      analytics.trackEvent(
        COLLABORATION_ANALYTICS_ACTIONS.RECEIVED_REALTIME_UPDATE,
        getCollaborationAnalyticsMetadata(fileId)
      );
      if (APIUtil.isEntry(fileId) || APIUtil.isDocument(fileId)) {
        const Store = APIUtil.isEntry(fileId) ? entryStore : documentStore;
        if (Store.inStore(fileId)) {
          const editorState = Store.getEditorState(fileId);
          // Don't update the entry if the client is viewing an old version
          if (editorState.openVersionId !== editorState.metadata?.latestVersionId) {
            return;
          }
          // Don't update the entry if the current user has started editing
          if (Store.hasUnsavedChanges(fileId)) {
            return;
          }
        }
        const Actions = APIUtil.isEntry(fileId) ? EntryActions : DocumentActions;
        Actions.open(fileId);
      }
    }
  },
  inactive: (
    fileId: string,
    {clientId}: GetRealtimeMessageData<typeof RealtimeMessageType.ENTRY_UPDATE>
  ): void => {
    if (APIUtil.isEntry(fileId) || APIUtil.isDocument(fileId)) {
      if (clientId && !isCurrentClient(clientId)) {
        const Store = APIUtil.isEntry(fileId) ? entryStore : documentStore;
        if (Store.inStore(fileId)) {
          const Actions = APIUtil.isEntry(fileId) ? EntryActions : DocumentActions;
          Actions.postServerUpdate(fileId, {isStale: true});
        }
      }
    }
  },
};
